<form #policyRuleForm="ngForm" (ngSubmit)="policyRuleForm.valid && close()">
    <div class="mon-dialog-body-with-footer auto-scroll policy-form-dialogs-rule px-3">
        <div class="row">
            <div class="col-48 mt-4">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('name')?.invalid && (policyRuleForm.form.get('name')?.dirty || policyRuleForm?.submitted)}">
                    <label class="col-form-label text-bold"><span translate>Rule name</span>*</label>
                    <div>
                        <form-field-input name="name" [(ngModel)]="cRule.name" [required]="true"></form-field-input>
                        <form-field-errors [input]="policyRuleForm.name" offset="0"></form-field-errors>
                    </div>
                </div>
            </div>

            <div class="col-48 mt-4">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('sub_entry')?.invalid && (policyRuleForm.form.get('sub_entry')?.dirty || policyRuleForm?.submitted)}">
                    <label class="col-form-label text-bold"><span translate>Meta Name</span>*</label>
                    <div>
                        <form-field-input name="sub_entry" [(ngModel)]="cRule.sub_entry" [required]="true"></form-field-input>
                        <form-field-errors [input]="policyRuleForm.form.get('sub_entry')" offset="0"></form-field-errors>
                    </div>
                </div>
            </div>

            <div class="col-48 mt-2">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('query')?.invalid && (policyRuleForm.form.get('query')?.dirty || policyRuleForm?.submitted)}">
                    <label for="query" class="col-form-label text-bold" translate>Characters</label> (<span translate>Number of characters in Meta Header text</span>):
                    <div class="input-group">
                        <mon-action-menu
                               class="rule-menu-action"
                               *ngIf="cRule.operator"
                               [monActionMenuItems]="dropdownOptions"
                               [monActionMenuClass]="'menu-panel-left-align'"
                               >{{selectedOption.translation}}</mon-action-menu>
                        <input name="query"
                               data-test="chars-query"
                               [min]="0"
                               [required]="true"
                               [(ngModel)]="cRule.query"
                               #queryFormControl="ngModel"
                               id="query"
                               type="number"
                               class="form-control">
                    </div>
                    <form-field-errors [input]="queryFormControl" offset="0"></form-field-errors>
                </div>
            </div>
        </div>
    </div>
    <div class="mon-dialog-footer text-right">
        <button
                data-test="save-button"
                [disabled]="policyRuleForm.invalid"
                class="btn btn-border-radius btn-secondary"
                type="submit"
                translate>
            Save
        </button>
    </div>
</form>
